<app-header *ngIf="showHeader()"></app-header>
<div class="global-padding">
  <router-outlet></router-outlet>
</div>
<ng-container *ngIf="loading$ | async">
  <div class="overlay"></div>
  <div style="color: var(--my-primary-color); z-index: 1000000" class="la-square-loader la-2x">
    <div></div>
  </div>
</ng-container>
